import React from 'react';
import { Box, Card, Skeleton, Stack, SvgIcon, Typography } from '@mui/material';
import { formatMoney } from '../../utils/constant';

export function MobileStatCardSkeleton() {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3, p: 1.5, height: '100%' }}>
      <Skeleton variant="rounded" width={32} height={32} />
      <Skeleton width="50%" height={30} sx={{ mt: 1 }} />
      <Skeleton width="80%" height={16} />
      <Skeleton width="60%" height={14} />
    </Card>
  );
}

export default function MobileStatCard({ title, value, icon, percentage, productCost, shippingCost, onClick }) {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        borderRadius: 3,
        p: 1.5,
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 120ms ease',
        '&:active': { transform: onClick ? 'scale(0.98)' : 'none' },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'action.selected',
            color: 'primary.main',
          }}
        >
          {icon && <SvgIcon sx={{ fontSize: 18 }}>{icon}</SvgIcon>}
        </Box>
        {percentage !== undefined && (
          <Typography variant="caption" sx={{ fontWeight: 700, color: 'success.main' }}>
            {`${percentage}%`}
          </Typography>
        )}
      </Stack>
      <Typography variant="h5" component="p" sx={{ fontWeight: 800, mt: 1, lineHeight: 1.2 }}>
        {value ?? 0}
      </Typography>
      <Typography variant="caption" component="p" sx={{ fontWeight: 600, color: 'text.primary' }} noWrap>
        {title}
      </Typography>
      <Typography variant="caption" component="p" color="text.secondary" noWrap sx={{ fontSize: 11 }}>
        {formatMoney(productCost || 0)}
      </Typography>
      <Typography variant="caption" component="p" color="text.secondary" noWrap sx={{ fontSize: 11 }}>
        {`+ ${formatMoney(shippingCost || 0)} shipping`}
      </Typography>
    </Card>
  );
}
